import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=1f947ca6&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=1f947ca6&prod&scoped=true&lang=css&external"
import style1 from "./MyAccount.vue?vue&type=style&index=1&id=1f947ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f947ca6",
  null
  
)

export default component.exports